export default "__VITE_ASSET__D5l9D5zg__"